/* ROOMART "serie" product card interactivity.
   Powers the colour dots on snippets/serie-product-card.liquid: clicking a dot
   swaps the card image, the price, and the product link to that colour's variant.
   Self-contained and idempotent so it can be included by multiple sections. */
(function () {
  if (window.__serieCardInit) return;
  window.__serieCardInit = true;

  function parseJSON(el) {
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function initCard(card) {
    if (card.__serieBound) return;
    card.__serieBound = true;

    var jsonEl = card.querySelector('[data-serie-variants]');
    if (!jsonEl) return;

    var data = parseJSON(jsonEl);
    if (!data || data.colorIndex === null || data.colorIndex === undefined) return;

    var imgEl = card.querySelector('[data-serie-image]');
    var priceEl = card.querySelector('[data-serie-price]');
    var dots = card.querySelectorAll('[data-serie-color]');

    function renderPrice(v) {
      var onSale = v.compareAtRaw && v.compareAtRaw > v.priceRaw;
      if (priceEl) {
        priceEl.innerHTML = onSale
          ? '<span class="original">' + v.compareAt + '</span><span class="sale">AB ' + v.price + '</span>'
          : '<span class="sale">AB ' + v.price + '</span>';
      }
      var imgWrap = card.querySelector('.serie-card__image');
      var badge = card.querySelector('.serie-badge');
      if (onSale) {
        if (!badge && imgWrap) {
          var b = document.createElement('span');
          b.className = 'serie-badge';
          b.textContent = 'Sale';
          imgWrap.appendChild(b);
        }
      } else if (badge) {
        badge.remove();
      }
    }

    function applyDot(dot) {
      var color = dot.getAttribute('data-serie-color');
      var variant = (data.variants || []).find(function (v) {
        return v.options && v.options[data.colorIndex] === color;
      });
      if (!variant) return;

      if (imgEl && variant.image) imgEl.src = variant.image;
      renderPrice(variant);
      card.setAttribute('href', data.productUrl + '?variant=' + variant.id);

      dots.forEach(function (d) {
        d.classList.remove('is-active');
      });
      dot.classList.add('is-active');
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        applyDot(dot);
      });
    });

    // Randomly shuffle the starting colour on each page load so the grid varies.
    if (dots.length > 1) {
      applyDot(dots[Math.floor(Math.random() * dots.length)]);
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-serie-card]').forEach(initCard);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  }

  // Re-init cards added by the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
